"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.polkadotUtil = exports.polkadotApi = exports.spec = exports.helpers = exports.chain = void 0;
// Allows for generic imports (eg. import {...} from 'avail-js-sdk')
__exportStar(require("./chain"), exports);
__exportStar(require("./helpers"), exports);
__exportStar(require("./spec"), exports);
// Allows for custom imports (eg. import {...} from 'avail-js-sdk/chain')
exports.chain = __importStar(require("./chain"));
exports.helpers = __importStar(require("./helpers"));
exports.spec = __importStar(require("./spec"));
// Re-exports to avoid duplication
__exportStar(require("@polkadot/api"), exports);
exports.polkadotApi = __importStar(require("@polkadot/api"));
exports.polkadotUtil = __importStar(require("@polkadot/util"));
